// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eGyU","colBig":"styles_colBig__JHCMC","colSmall":"styles_colSmall__2NvS9","shopifyNameWrapper":"styles_shopifyNameWrapper__2_Pd3"};